import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnlocked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 16.115",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Component_37_1",
		"data-name": "Component 37 \\u2013 1",
		transform: "translate(0 0.514)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Rectangle_1487",
			"data-name": "Rectangle 1487",
			transform: "translate(0 6.601)",
			fill: "none",
			stroke: "#fff",
			strokeLinejoin: "round",
			strokeWidth: 1,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 9,
				stroke: "none"
			}), /* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 13,
				height: 8,
				fill: "none"
			})]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_799",
			"data-name": "Path 799",
			d: "M10.5,9.593V6.661a3.665,3.665,0,0,1,7.257-.733",
			transform: "translate(-7.128 -2.992)",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})]
	})
});
export default SvgUnlocked;
